import React, { memo } from 'react';

import { Text } from '@thefarmersfront/kitchen';

import styles from './Calendar.module.scss';

type TypeCalendarProps = {
  /**
   * 캘린더에 표시할 Date 또는 null 값의 배열
   */
  days: (Date | null)[];
  /**
   * 커스텀 일 컴포넌트를 렌더링하는 콜백 함수
   */
  renderDay?: (date: Date | null) => React.ReactNode;
};

const Calendar = ({ days, renderDay }: TypeCalendarProps) => {
  const DAY_NAMES = ['월', '화', '수', '목', '금', '토', '일'];

  return (
    <div className={styles['calendar-container']}>
      <div className={styles['calendar-header-wrapper']}>
        <div className={styles['calendar-header']}>
          {DAY_NAMES.map((day) => (
            <Text key={day} className={styles['day-name']} size="xlarge" color="tertiary">
              {day}
            </Text>
          ))}
        </div>
      </div>
      <div className={styles['calendar-grid']}>
        {days.map((date, index) => (
          <div key={`${date?.toDateString()}-${index}`} className={styles['date']}>
            {date && renderDay ? (
              renderDay(date)
            ) : (
              <Text size="xlarge" color="tertiary" element="p">
                {date?.getDate() ?? ''}
              </Text>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default memo(Calendar);
